<template>
  <v-app>
    <v-progress-linear
      indeterminate
      color="teal lighten-2"
      :active="loading"
      class="loading-bar"
    ></v-progress-linear>

    <dashboard-core-app-bar />

    <dashboard-core-drawer />

    <v-dialog
      v-model="hasNotification"
      v-if="message || warning || error"
      width="60%"
      hide-overlay
      content-class="messageDialogue"
    >
      <v-card>
        <v-alert
          v-if="message"
          type="success"
          border="left"
          text
          dismissible
          close-text="Close"
          style="margin-bottom: 0;"
          >{{ message }}</v-alert
        >

        <v-alert
          v-if="error"
          type="error"
          border="left"
          text
          dismissible
          close-text="Close"
          style="margin-bottom: 0;"
          >{{ error }}</v-alert
        >

        <v-alert
          v-if="warning"
          type="warning"
          border="left"
          text
          dismissible
          close-text="Close"
          style="margin-bottom: 0;"
          >{{ warning }}</v-alert
        >
      </v-card>
    </v-dialog>

    <!-- <v-container class="fill-height" fluid>
      <v-row align="center" justify="center" v-show="error">
        <v-col cols="12" sm="10" md="6">
          <v-alert type="error" border="left">{{ error }}</v-alert>
          <v-alert type="success" border="left">{{ message }}</v-alert>
          <v-alert type="warning" border="left">{{ warning }}</v-alert>
        </v-col>
      </v-row>
    </v-container>-->
    <dashboard-core-view />
  </v-app>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import common from "@/store/common/module/common";

@Component({
  components: {
    DashboardCoreAppBar: () => import("@/components/layout/AppBar.vue"),
    DashboardCoreDrawer: () => import("@/components/layout/Drawer.vue"),
    DashboardCoreView: () => import("@/components/layout/View.vue"),
  },
})
export default class UIWrapper extends Vue {
  name = "UIWrapper";

  dialog = true;

  async mounted() {
    await common.populateLanguages();
    await common.populateTranslates();
    this.$i18n.state.translates = common.translates;
    this.abc = this.$i18n.t(
      "Show Early Start Button to Driver for Future Duty"
    );
  }

  get hasNotification() {
    console.log(this.error);
    if (this.error == ""  && (this.message != "" || this.warning != "")) {
      setTimeout(() => {
        this.hasNotification = false;
      }, 5000);
    }
    return (
      (this.error != null && this.error !== "") ||
      (this.message != null && this.message !== "") ||
      (this.warning != null && this.warning !== "")
    );
  }

  set hasNotification(value) {
    if (!value) {
      common.setError("");
      common.showMessage("");
      common.showWarning("");
    }
  }

  get error() {
    return common.error;
  }

  get message() {
    return common.message;
  }

  get warning() {
    return common.warning;
  }

  get loading() {
    return common.loading;
  }
}
</script>

<style scoped>
.loading-bar {
  position: fixed;
  z-index: 10;
}
</style>

<style>
.messageDialogue {
  position: fixed !important;
  top: 36px !important;
}
</style>
